import React from 'react'

const UnderDevelopment = () => {
  return (
    <div className='flex items-center justify-center h-screen'>
      <span className='text-2xl animate-bounce'> Under development...</span>
    </div>
  )
}

export default UnderDevelopment
